// extracted by mini-css-extract-plugin
export default {"recipeGridDescription":"G26b245","recipeGridDescriptionText":"G3d036a"};